import React from 'react';

export default function LegalPage({ title, children, lastUpdated }) {
  return (
    <div className="bg-offwhite dark:bg-[#121212] min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-3xl mx-auto">
        
        <div className="mb-12 anim-hidden anim-visible">
          <p className="eyebrow mb-4">Legal Info</p>
          <h1 className="display-sm text-gray-800 dark:text-white mb-4 tracking-tight">
            {title}
          </h1>
          <p className="text-xs text-gray-500 dark:text-gray-400 font-medium tracking-wide uppercase">
            Last Updated: {lastUpdated}
          </p>
        </div>

        <div className="bg-white dark:bg-[#1c1c1e] rounded-3xl border border-gray-200/80 dark:border-white/10 dark:border-white/10 p-8 md:p-12 shadow-sm anim-hidden anim-visible anim-delay-1">
          <div className="prose prose-sm max-w-none prose-headings:font-bold prose-headings:text-gray-800 dark:text-white prose-headings:tracking-tight prose-p:text-gray-500 dark:text-gray-400 prose-p:leading-relaxed prose-a:text-accent prose-a:no-underline hover:prose-a:text-accent-hover prose-li:text-gray-500 dark:text-gray-400">
             {children}
          </div>
        </div>

      </div>
    </div>
  );
}
